module.exports = __webpack_public_path__ + "static/media/vehicle-type-bicycle-white.a878688e.svg";